import WikiListView from "./WikiListView";

import "./WikiListView.scss";

export * from "./WikiListView.types";

export { WikiListView };
